import React from "react";
import { Field, Input, Textarea, SectionTitle } from "./_shared";

export default function AboutEditor({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div>
      <SectionTitle title="Sección Sobre" subtitle="Bloque 'Un Estudio, dos Universos'" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Eyebrow (texto pequeño)"><Input value={value.eyebrow} onChange={(e) => set("eyebrow", e.target.value)} /></Field>
        <div />
        <Field label="Título prefijo"><Input value={value.title_prefix} onChange={(e) => set("title_prefix", e.target.value)} /></Field>
        <Field label="Palabra destacada 1 (naranja)"><Input value={value.title_word1} onChange={(e) => set("title_word1", e.target.value)} /></Field>
        <Field label="Conector medio"><Input value={value.title_middle} onChange={(e) => set("title_middle", e.target.value)} /></Field>
        <Field label="Palabra destacada 2 (teal)"><Input value={value.title_word2} onChange={(e) => set("title_word2", e.target.value)} /></Field>
        <div className="md:col-span-2">
          <Field label="Descripción"><Textarea rows={4} value={value.description} onChange={(e) => set("description", e.target.value)} /></Field>
        </div>
      </div>
    </div>
  );
}
